const DELIMITER: string = '-';
const LENGTH_OF_SCRIPT_PART: number = 4;

export default function getOgmaSupportedLanguageTag(languageTag: string): string {
    languageTag = languageTag.toLowerCase();

    if (languageTag.lastIndexOf('zh-', 0) === 0) {
        switch (languageTag) {
            case 'zh-cht':
            case 'zh-hant':
            case 'zh-hk':
            case 'zh-tw':
                return 'zh-cht';
            default:
                return 'zh-chs';
        }
    }

    let lengthToGrab = languageTag.indexOf(DELIMITER, 1);

    // The input string is already something like 'en', so just return it.
    if (lengthToGrab === -1) {
        return languageTag;
    }

    // We continue looking for an additional delimiter and check to see if the contents between are exactly 4 characters long.
    // According to the IETF definition of a language tag, a length of 4 indicates a script.
    let possibleEndOfScriptIndex = languageTag.indexOf(DELIMITER, lengthToGrab + DELIMITER.length);

    // If there is no other delimiter, it might be something like 'sr-cyrl', which we should return.
    // However we must also be prepared for it to be 'sr-nnn' which does not contain a script.
    if (possibleEndOfScriptIndex === -1) {
        possibleEndOfScriptIndex = languageTag.length;
    }

    if (possibleEndOfScriptIndex - lengthToGrab == DELIMITER.length + LENGTH_OF_SCRIPT_PART) {
        lengthToGrab = possibleEndOfScriptIndex;
    }

    return languageTag.substring(0, lengthToGrab);
}
